// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCKSYn1NExOnEOHjXliWeXFNJTQrCaNIUg",
  authDomain: "anthology-site.firebaseapp.com",
  projectId: "anthology-site",
  storageBucket: "anthology-site.appspot.com",
  messagingSenderId: "313482202064",
  appId: "1:313482202064:web:a87feeff8e4c3df7b787d5",
  measurementId: "G-YRZPTZQRXY"
};